export default __webpack_public_path__ + "img/triangle_el.b1b4b67.svg";